import {create} from 'zustand';
import {persist} from 'zustand/middleware';

export interface ViewAsBroker {
  agentId: string;
  agentName: string;
}

interface ViewAsState {
  /**
   * When set, a client admin is previewing the broker portal as this broker.
   * The agent id is echoed to the API on every request (see the tRPC client's
   * `x-view-as-broker-id` header) and drives broker routing/nav on the frontend.
   */
  viewAsBroker: ViewAsBroker | null;
  setViewAs: (broker: ViewAsBroker) => void;
  clearViewAs: () => void;
}

export const useViewAsStore = create<ViewAsState>()(
  persist(
    (set) => ({
      viewAsBroker: null,
      setViewAs: (broker) => set({viewAsBroker: broker}),
      clearViewAs: () => set({viewAsBroker: null}),
    }),
    {
      name: 'view-as-broker',
      partialize: (state) => ({viewAsBroker: state.viewAsBroker}),
    },
  ),
);

/**
 * Non-hook accessor for the currently impersonated broker id. Used by the tRPC
 * client to attach the `x-view-as-broker-id` header outside of React.
 */
export function getViewAsBrokerId(): string | null {
  return useViewAsStore.getState().viewAsBroker?.agentId ?? null;
}
